import { OpenSearchRequestFilter } from '@libs/shared/domain/aggregations/opensearch/open-search-query.schema';
import { CodeRequestResultType } from '@shared/models/code-request-result.enum';
import dayjs from 'dayjs';

export type PlaybookStatValue = {
  current: number;
  previous: number;
};

export type PlaybookStat = {
  id: string;
  title: string;
  value?: PlaybookStatValue | null;
  tooltip?: string;
};

export type PlaybookDetection = {
  title: string;
  icon: string;
  description: string;
  flagRules: string[];
  value?: number;
  calculateFromNcpdps?: boolean;
};

export type Playbook = {
  id: string;
  title: string;
  description: string;
  stats: PlaybookStat[];
  detections?: PlaybookDetection[] | null;
  flags: string[];
};

export type ChartDetection = {
  flag: string;
  value?: number;
};

export type PlaybookDetectionCategories = Record<string, Record<string, PlaybookDetection>>;

// LAST 24 HOURS
export const CREATED_DETECTIONS_FILTER: OpenSearchRequestFilter = {
  operator: 'range',
  field: 'created',
  value: {
    created: {
      gte: dayjs().subtract(24, 'hours').toISOString(),
      lte: dayjs().toISOString(),
    },
  },
};
export const CREATED_DETECTIONS_TRAILING_FILTER: OpenSearchRequestFilter = {
  operator: 'range',
  field: 'created',
  value: {
    created: {
      gte: dayjs().subtract(1, 'day').subtract(24, 'hours').toISOString(),
      lte: dayjs().subtract(1, 'day').toISOString(),
    },
  },
};

export function getNoDemoNcpdpsFilter(demoNcpdps: string[]): OpenSearchRequestFilter {
  return {
    operator: 'in',
    field: 'pharmacyNcpdp',
    value: demoNcpdps,
    negate: true,
  };
}

export function getFlagsFilter(flagsList: string[], firstTime: boolean = false): OpenSearchRequestFilter {
  return {
    operator: 'in',
    field: firstTime ? 'pharmacyNewFlagsList' : 'flagsList',
    value: flagsList,
  };
}

export function getFlagRulesFilters(flagRules: string[]): OpenSearchRequestFilter[] {
  return flagRules.map(flags => ({
    operator: 'in',
    field: 'flagsList',
    value: flags.split(','),
  }));
}

export function getProductFilter(productNdc: string): OpenSearchRequestFilter {
  return {
    operator: 'equal',
    field: 'productNdc',
    value: productNdc,
  };
}

export function getTenantFilter(tenantId: string, negate = false): OpenSearchRequestFilter {
  return {
    operator: 'equal',
    field: 'tenantId',
    value: tenantId,
    negate,
  };
}

export function getClaimStatusFilter(claimStatuses: CodeRequestResultType[]): OpenSearchRequestFilter {
  return {
    operator: 'in',
    field: 'status',
    value: claimStatuses,
  };
}
